export default __webpack_public_path__ + "static/media/dashboardIcon.82d2f708.svg";